import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-12 sm:py-14 px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-grid-pattern" data-id="element-147">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-transparent to-navy-950 pointer-events-none" data-id="element-148" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-149">
        <FadeIn data-id="element-150">
          <div className="relative p-8 sm:p-12 md:p-16 rounded-3xl bg-navy-900/80 border border-gold-500/20 backdrop-blur-md text-center shadow-[0_0_50px_rgba(201,168,76,0.05)]" data-id="element-151">
            <Quote className="w-12 h-12 text-gold-500/20 absolute top-8 left-8" data-id="element-152" />
            <Quote className="w-12 h-12 text-gold-500/20 absolute bottom-8 right-8 rotate-180" data-id="element-153" />

            <p className="text-xl sm:text-2xl md:text-3xl font-serif text-white leading-relaxed mb-8 relative z-10" data-id="element-154">
              Lo que cambia en 7 días no es lo que te pasa, sino{' '}
              <span className="text-gold-400 italic" data-id="element-155">desde dónde lo ves</span>.
            </p>

            <div className="space-y-6 text-lg text-gray-300 font-light relative z-10 max-w-2xl mx-auto" data-id="element-156">
              <p data-id="element-157">
                Cuando dejas de resistirte a los hitos pactados y activas al
                Observador, el peso del sufrimiento desaparece. El cuerpo se
                desinflama, la mente se silencia y la energía vital regresa.
              </p>
              <p className="font-medium text-gold-400" data-id="element-158">
                No es un milagro; es una consecuencia técnica de dejar de ser
                fiel a la ignorancia y empezar a ser fiel al Origen.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}